import type { ReactNode } from "react";
import { Text, cn } from "@musa.tech/design-system";

interface KpiCardShellProps {
  label: string;
  /** Valor principal (+ variação, se houver) — linha imediatamente sob o label. */
  header: ReactNode;
  /** As linhas de submétrica, abaixo do divisor. */
  rows: ReactNode;
  className?: string;
}

/**
 * Moldura comum aos 3 KPI cards do Overview: label, valor, divisor,
 * submétricas. Visual do Figma 124:12999/124:13010/124:13026 — fundo
 * primary-50, padding 24 (p-6), radius 16 (rounded-2xl), gap 8 (gap-2) entre
 * blocos, todos valores exatos na escala padrão do Tailwind.
 */
export const KpiCardShell = ({
  label,
  header,
  rows,
  className,
}: KpiCardShellProps) => (
  <div className={cn("flex flex-col gap-2 rounded-2xl bg-primary-50 p-6", className)}>
    <Text variant="body" size="small" className="text-neutral-900">
      {label}
    </Text>
    {header}
    <div className="h-px w-full bg-primary-900" />
    <div className="flex flex-col gap-2">{rows}</div>
  </div>
);
